module.exports = __webpack_public_path__ + "img/ladder_do_open.643404ca.png";